import React, { useState } from 'react';

const LibraryPage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(true);

  const handleLoad = () => {
    setIsLoading(false);
  };

  return (
    <div className="w-full bg-white flex flex-col relative" style={{ minHeight: 'calc(100dvh - 64px)' }}>
      {/* 로딩 인디케이터 */}
      {isLoading && (
        <div className="absolute inset-0 z-10 flex flex-col items-center justify-center bg-white">
          <div className="relative mb-6">
            <div className="w-16 h-16 bg-indigo-600 rounded-2xl flex items-center justify-center text-white font-black text-2xl shadow-2xl animate-bounce">
              L
            </div>
            <div className="absolute -bottom-4 left-1/2 -translate-x-1/2 w-12 h-1.5 bg-black/5 rounded-full blur-sm animate-pulse"></div>
          </div>
          
          <h3 className="text-lg font-black text-gray-900 mb-2 italic tracking-tighter uppercase">
            Connecting to Library
          </h3>
          
          <div className="flex flex-col items-center gap-1">
            <p className="text-sm font-bold text-indigo-600 animate-pulse">
              통합자료실 서버에 접속 중입니다... 📡
            </p>
            <p className="text-xs text-gray-400 font-medium italic">
              "대용량 리소스를 안전하게 불러오고 있어요!"
            </p>
          </div>

          <div className="mt-8 w-40 h-1 bg-gray-100 rounded-full overflow-hidden">
            <div className="h-full bg-indigo-600 rounded-full w-1/3 animate-loading-slide"></div>
          </div>
        </div>
      )}

      {/* 
        전달해주신 Cloud Functions 프록시 URL을 iframe으로 임베딩합니다.
        높이는 헤더(64px)를 제외한 나머지 화면 전체를 차지하도록 설정합니다.
      */}
      <iframe
        src="https://us-central1-makerstory-ssamlink.cloudfunctions.net/ssam_proxy"
        className={`w-full flex-1 border-none transition-opacity duration-700 ${isLoading ? 'opacity-0' : 'opacity-100'}`}
        style={{ height: 'calc(100dvh - 64px)' }}
        onLoad={handleLoad}
        title="메이커스토리 통합자료실"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowFullScreen
      />

      <style>{`
        @keyframes loading-slide {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(250%); }
        }
        .animate-loading-slide {
          animation: loading-slide 1.5s infinite ease-in-out;
        }
      `}</style>
    </div>
  );
};

export default LibraryPage;
